// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Utils
import { getWidgetURL } from 'utils/widget'
import { beautifyURL } from 'utils/url'

// Atoms
import Fade from '@material-ui/core/Fade'
import Link from 'atoms/Link'
import { ScrollSection } from 'atoms/ScrollSections'

// Icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

// Components
import WidgetCode from 'components/Widget/Code'
import StepContainer from './StepContainer'
import StepTitle from './StepTitle'
import StepSpacer from './StepSpacer'
import StepButton from './StepButton'
import StepParagraph from './StepParagraph'
import ShareLinks from './FinishStepShareLinks'

// Styles
const styles = {
  completeButtonWrapper: {
    textAlign: 'right',
  },
  installStep: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    fontSize: 24 * 0.65,
    color: '#565759',
    paddingLeft: 25 * 0.65,
  },
  widgetCodeExpander: {
    display: 'inline',
    background: 'none',
    border: 0,
    padding: 0,
    margin: 0,
    font: 'inherit',
    color: 'inherit',
    cursor: 'pointer',
    '& > svg': {
      verticalAlign: 'middle',
    },
    '&:focus': {
      outline: 0
    },
  },
  siteBuilders: {
    marginBottom: -15 * 0.65,
    marginRight: -15 * 0.65,
    '& > *': {
      marginBottom: 15 * 0.65,
      marginRight: 15 * 0.65,
    }
  },
}

export default
@withStyles(styles)
class OnboardingCustomizationStep extends Component {
  static propTypes = {
    meGetter: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  }

  state = {
    showWidgetCode: false,
  }

  toggleWidgetCode = () => {
    const { showWidgetCode } = this.state
    this.setState({ showWidgetCode: !showWidgetCode })
  }

  renderSiteBuilders() {
    const { classes } = this.props
    const builders = ['Wordpress', 'Squarespace', 'Weebly', 'Wix', 'Other']
    return (
      <div className={classes.siteBuilders}>
        { builders.map(name => (
          <StepButton
            key={name}
            square
            component={Link}
            external
            target="_blank"
            to="http://telegra.ph/Adding-indemandly-to-your-website-03-06"
          >
            { name }
          </StepButton>
        )) }
      </div>
    )
  }

  renderContent = (sectionProps) => {
    const { meGetter, classes } = this.props
    const { disabled } = sectionProps
    const { showWidgetCode } = this.state
    const domain = meGetter.isSucceded && meGetter.data.business && meGetter.data.business.domain
    return (
      <StepContainer>
        <StepTitle>You’re good to go</StepTitle>
        { !!domain && (
          <Fade in>
            <div>
              <StepSpacer small />
              <StepParagraph>
                { beautifyURL(getWidgetURL(domain)) }
              </StepParagraph>
              <StepSpacer />
              <StepTitle secondary>
                Install it on your website
              </StepTitle>
              <StepSpacer extrasmall />
              <div className={classes.installStep}>
                <button
                  tabIndex="-1"
                  type="button"
                  className={classes.widgetCodeExpander}
                  onClick={this.toggleWidgetCode}
                >
                  1. Copy your code here
                  { showWidgetCode ? <ExpandLessIcon /> : <ExpandMoreIcon /> }
                </button>
                <Fade in={showWidgetCode} unmountOnExit>
                  <div>
                    <StepSpacer extrasmall />
                    <WidgetCode domain={domain} />
                    <StepSpacer extrasmall />
                  </div>
                </Fade>
              </div>
              <div className={classes.installStep}>
                2. Paste it in your website builder
                <StepSpacer extrasmall />
                { this.renderSiteBuilders() }
              </div>
              <StepSpacer small />
              <StepTitle secondary>
                Share on social
              </StepTitle>
              <StepSpacer extrasmall />
              <ShareLinks meGetter={meGetter} />
            </div>
          </Fade>
        ) }
        <StepSpacer />
        <div className={classes.completeButtonWrapper}>
          <StepButton component={Link} to="/customize" disabled={disabled}>
            Start customizing &rarr;
          </StepButton>
        </div>
      </StepContainer>
    )
  }

  render() {
    const { classes, ...rest } = this.props
    return (
      <ScrollSection {...rest}>
        { this.renderContent }
      </ScrollSection>
    )
  }
}
